// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"1671": "js-legacy","8626": "head-common","878": "stage_automation_icon","9474": "vendor",}[chunkId] || chunkId) + "-" + {"1671": "f72381ee21901378","4276": "5549c740df38f3b1","5316": "fda754279bedb588","5680": "d284f10647515ca8","7064": "c39df16beb84a3d8","8476": "a539a0d0508a5572","8626": "9ef1fabfcd8f8e76","878": "39c4f8da5787be4b","9474": "927ca06961a08951",}[chunkId] + ".js"
}